export const DEFAULT_LOAD_PREVIOUS_BUTTON_TEXT = "LOAD {{number}} PREVIOUS";
